import { useMemo } from 'react';
import { ApolloClient, HttpLink, InMemoryCache, useApolloClient } from '@apollo/client';

import { clientConfig } from '@/config/clientConfig';
import { useAuthStore } from '@/shared/store/auth.store';

export const useDirectUrlClient = () => {
  const { legacyToken } = useAuthStore();
  const defaultGqlClient = useApolloClient();

  const gqlClient = useMemo(() => {
    if (legacyToken) {
      return new ApolloClient({
        link: new HttpLink({
          uri: clientConfig.api.directGraphqlUrl,
          headers: {
            authorization: legacyToken,
          },
        }),
        cache: new InMemoryCache(),
      });
    }
    return defaultGqlClient;
  }, [defaultGqlClient, legacyToken]);

  return gqlClient;
};
